import { View, Utils } from '../vendor/kerneljs';

const SiteHeader = View.extend({
	savedWindowWidth: 0,
	mobileViewport: false,
	lastScrollTop: window.scrollY || document.documentElement.scrollTop,

	initialize: function(){

		this.htmlRef = Utils.find('html')[0];
		this.inner = this.find('.main-navigation');

		this.lastScrolled = 0;
		this.scrolledDown = 0;
		this.scrolledUp = 0;
		this.scrollTrigger = 300;

		Utils.on(window, 'scroll', this.scrollHandler.bind(this) );
		this.scrollHandler();

		Utils.on(window, 'resize', this.resizeHandler.bind(this) );
		this.resizeHandler();

		this.eventEmitter.on('siteheader:stick', this.stickHandler.bind(this));
		this.eventEmitter.on('siteheader:update', this.updateHandler.bind(this));
	},

	updateHandler: function() {
		this.scrollHandler();
	},

	stickHandler: function() {
		this.toggleSticky(true);
	},

	resizeHandler: function() {
		let width = window.innerWidth;
		if ( this.savedWindowWidth === width ) return false;
		else {
			this.savedWindowWidth = width;
			this.mobileViewport = true;
			if ( width > 566 ) { //for this component
				this.mobileViewport = false;
			}
		}
	},

	scrollHandler: function() {
		let st = window.scrollY || document.documentElement.scrollTop
		this.lastScrollTop = st <= 0 ? 0 : st


		this.lastScrolled = (document.documentElement.scrollTop||document.body.scrollTop);
	},

	toggleSticky: function(isSticky) {
		if ( isSticky ) {
			this.addClass('is-sticky');
			Utils.addClass(this.htmlRef, 'is-sticky-mode');
		}
		else {
			if ( !this.canUnstick() ) return false;
			this.removeClass('is-sticky');
			Utils.removeClass(this.htmlRef, 'is-sticky-mode');

			this.eventEmitter.emit('siteheader:unstick');
		}

	},

	canUnstick: function() {
		return !(Utils.hasClass(this.htmlRef, 'is-minibasket-mode')) && !(Utils.hasClass(this.htmlRef, 'is-mobilenav-mode'));
	}

});

(function(){
	Utils.each(Utils.find('.js--site-header'), function(elem) {
		new SiteHeader( {el: elem} );
	});
})();

export default SiteHeader;
